<style>
.journer {
    min-height: 600px;
}

.el-tabs__item.is-active {
    color: #fff;
    background-color: #006BFF !important;
    color: #FFFFFF !important;
}

.el-tabs__nav-scroll {
    padding-left: 20px;
}

.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    margin-right: 10px;
}

.el-tabs__active-bar {
    display: none !important;
}

.el-tabs__header {
    padding: 9px 0;
    background: #FFF;
    margin-bottom: 1px;
}

.el-tabs__content {
    background: #FFF;
}

.el-tabs__item {
    width: 160px;
    font-size: 14px;
    font-weight: 400;
    color: #232020;
    max-width: 160px;
    height: 30px;
    width: 100%;
    font-size: 14px;
    background-color: #ebf4ff;
    border-radius: 50%;
    border-radius: 50px;
    text-align: center;
    line-height: 30px;
    color: #232020;
    cursor: pointer;
    box-sizing: border-box;
}

.el-tabs__nav-wrap::after {
    height: 0px;
}

.journer .Incoming_Source_type ul {
    display: flex;
}

.journer .Incoming_Source_type ul li {
    cursor: pointer;
    max-width: 140px;
    width: 100%;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    line-height: 48px;
}

.active {
    color: #006BFF;
}

.journer .table_title {
    display: flex;
    justify-content: space-between;
    background: #232020;
    padding: 15px 86px 15px 40px;
    font-size: 14px;
    color: #fff;
    font-weight: 900;
}

.journer .table_title div {
    font-size: 14px;
    color: #fff;
    font-weight: 900;
}

.data_source {
    display: flex;
    justify-content: space-between;
    padding: 13px 86px 13px 40px;
    font-size: 14px;
    align-items: center;
}

.data_source div,
.table_title div {
    max-width: 100px;
    width: 100%;
    text-align: center;
}

.data_source:nth-child(odd) {
    background: #EBF1FA;
}

.data_source:nth-child(even) {
    background: #ffffff;
}

.Country {
    max-width: 220px !important;
    width: 100%;
}
</style>
<template>
    <div class="journer">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="Visit" name="first">
                <div class="table_title">
                    <div class="Country">Country</div>
                    <div>Traffic Share</div>
                    <div>All Devices</div>
                    <div>Desktop</div>
                    <div>Mobile</div>
                    <div>Tablet</div>
                </div>
                <ul>
                    <li class="data_source" v-for="item in country_data" :key="item.country">
                        <div class="Country" style="display: flex;gap: 2px;align-items: center;">
                            <!-- <img style="width: 36px;height: 36px;padding-right: 20px;" src="../assets/img/examination_01.webp" alt=""> -->
                            <span>{{ item.country }}</span>
                        </div>
                        <div class="">{{ item.traffic_share }}</div>
                        <div class="">{{ item.page_views }}</div>
                        <div class="">{{ item.desktop }}</div>
                        <div>{{ item.mobile }}</div>
                        <div>{{ item.tablet }}</div>
                    </li>
                </ul>
            </el-tab-pane>
            <el-tab-pane label="Unique Visitor" name="second">Unique Visitor</el-tab-pane>
        </el-tabs>
        <div class="trend_load">
            <i class="el-icon-loading"></i>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import cookies from 'js-cookie'
export default {
    data () {
        return {
            activeName: 'first',
            country_data: [],
            users: {
                lastings: '',
                days: '',
                timeUnit: '',
                traffic: '',
            },
        }
    },
    watch: {
        users: {
            handler: function (oldval, newval) {
                if (JSON.stringify(newval.lastings) != "null" & JSON.stringify(newval.days) != "null" & JSON.stringify(newval.timeUnit) != "null") {
                    // console.log("duiduidui");
                    this.getDatas()
                }
            },
            deep: true
        }
    },
    mounted () {
        let this_s = this
        setInterval(function () {
            this_s.users.lastings = sessionStorage.getItem("lasting")
            this_s.users.days = sessionStorage.getItem("days")
            this_s.users.timeUnit = sessionStorage.getItem("timeUnit")
            this_s.users.traffic = sessionStorage.getItem("traffic")
            // console.log(this.users.lastings,this.users.days,this.users.timeUnit);
        }, 2000)
        // this.getDatas()

        $(".Incoming_Source_type ul li").eq(0).addClass("active").siblings().removeClass("active")
    },
    methods: {
        Trend (e) {
            $(".Incoming_Source_type ul li").eq(e).addClass("active").siblings().removeClass("active")
        },

        getDatas () {
            let this_f = this
            $.ajax({
                type: "get",
                url: "https://google-analytics-test.canglankeji.com/api/traffic/country",
                headers: {
                    Authorization: "Bearer " + cookies.get("token"),
                },
                data: {
                    baseTime: this.users.lastings,
                    value: this.users.days,
                    timeUnit: this.users.timeUnit,
                    domain: this.users.traffic,
                    // baseTime: "2023-03-25",
                    // value: "3",
                    // timeUnit: "day",
                },
                dataType: 'json',
                success: function (res) {
                    // console.log(res)
                    if (res.message == "OK") {
                        this_f.country_data = res.result.table_data
                    }
                    $(".trend_load").hide()
                }
            })
        },
        handleClick (tab, event) {
            console.log(tab, event)
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/views/Country.vue